import produce from "immer"
import { MarkovDataset } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovDataset: MarkovDataset = {
    id: null,
    modelId: null,
    name: "",
    order: 0,
}

const initMarkovDatasetState: types.MarkovDatasetState = {
    datasets: [],
    datasetSelected: null,
    datasetEdit: initMarkovDataset,

    reloadList: true,
    reloadEdit: true,
}

const markovDatasetReducer = produce((
    draft: types.MarkovDatasetState = initMarkovDatasetState,
    action: ActionTypes = null,
): types.MarkovDatasetState => {
    switch (action.type) {
        case types.MARKOV_DATASETS:
            draft.datasets = action.datasets
            return draft

        case types.MARKOV_DATASET_SELECTED:
            draft.datasetSelected = action.dataset
            return draft

        case types.MARKOV_DATASET_EDIT:
            draft.datasetEdit = action.dataset
            return draft

        case types.MARKOV_DATASET_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_DATASET_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovDatasetReducer
